//#region src/variants/variants_split_button.js
var variants_split_button_default = {
	defaults: { props: { kind: { tokenCategory: "color:d-btn--:color" } } },
	exclusions: [
		{
			when: { importance: (v) => v !== "clear" },
			hide: { props: ["showDivider"] }
		},
		{
			when: { kind: "muted" },
			disableValues: { props: { importance: ["primary"] } }
		},
		{
			when: { importance: "primary" },
			disableValues: { props: { kind: ["muted"] } }
		}
	],
	default: {
		props: { endTooltipText: { initialValue: "More calling options" } },
		slots: {
			default: { initialValue: "Place call" },
			dropdownList: { initialValue: "<dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\"> Option 1 </dt-list-item>\n<dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\"> Option 2 </dt-list-item>\n <dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\"> Option 3 </dt-list-item>" }
		}
	},
	outlined: {
		props: {
			importance: { initialValue: "outlined" },
			endTooltipText: { initialValue: "More calling options" }
		},
		slots: {
			default: { initialValue: "Place Call" },
			dropdownList: { initialValue: "<dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\"> Option 1 </dt-list-item>\n<dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\"> Option 2 </dt-list-item>\n<dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\"> Option 3 </dt-list-item>" }
		}
	},
	"clear muted": {
		props: {
			importance: { initialValue: "clear" },
			kind: { initialValue: "muted" },
			endTooltipText: { initialValue: "More calling options" }
		},
		slots: {
			default: { initialValue: "Place Call" },
			dropdownList: { initialValue: "<dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\"> Option 1 </dt-list-item>\n<dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\"> Option 2 </dt-list-item>\n<dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\"> Option 3 </dt-list-item>" }
		}
	},
	"end disabled": {
		props: {
			endDisabled: { initialValue: true },
			endTooltipText: { initialValue: "More calling options" }
		},
		slots: {
			default: { initialValue: "End disabled" },
			dropdownList: { initialValue: "<dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\"> Option 1 </dt-list-item>\n<dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\"> Option 2 </dt-list-item>\n<dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\"> Option 3 </dt-list-item>" }
		}
	},
	"start loading": {
		props: {
			startLoading: { initialValue: true },
			importance: { initialValue: "outlined" },
			endTooltipText: { initialValue: "More calling options" }
		},
		slots: {
			default: { initialValue: "Place call" },
			dropdownList: { initialValue: "<dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\"> Option 1 </dt-list-item>\n<dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\"> Option 2 </dt-list-item>\n<dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\"> Option 3 </dt-list-item>" }
		}
	},
	"with start icon": {
		props: {
			importance: { initialValue: "outlined" },
			endTooltipText: { initialValue: "More calling options" }
		},
		slots: {
			startIcon: { initialValue: "<dt-icon-phone :size=\"iconSize\" />" },
			default: { initialValue: "Place call" }
		}
	},
	"icon only muted": {
		props: {
			importance: { initialValue: "outlined" },
			kind: { initialValue: "muted" },
			endTooltipText: { initialValue: "More calling options" },
			startTooltipText: { initialValue: "Place call" }
		},
		slots: { startIcon: { initialValue: "<dt-icon-phone :size=\"iconSize\" />" } }
	},
	"with leading": {
		props: {
			importance: { initialValue: "outlined" },
			endTooltipText: { initialValue: "More options" },
			alphaLeadingClass: { initialValue: "d-pis-100" }
		},
		slots: {
			default: { initialValue: "Place Call" },
			leading: { initialValue: "<dt-badge kind=\"count\" text=\"3\" />" },
			dropdownList: { initialValue: "<dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\"> Option 1 </dt-list-item>\n<dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\"> Option 2 </dt-list-item>\n<dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\"> Option 3 </dt-list-item>" }
		}
	},
	"clear muted no divider": {
		props: {
			importance: { initialValue: "clear" },
			kind: { initialValue: "muted" },
			showDivider: { initialValue: false },
			endTooltipText: { initialValue: "More calling options" }
		},
		slots: {
			default: { initialValue: "Place Call" },
			dropdownList: { initialValue: "<dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\"> Option 1 </dt-list-item>\n<dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\"> Option 2 </dt-list-item>\n<dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\"> Option 3 </dt-list-item>" }
		}
	}
};
//#endregion
export { variants_split_button_default as default };

//# sourceMappingURL=variants_split_button.js.map